import { ArrowRight, Check, Eye, PlusCircle, Search, Ship } from 'lucide-react'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import vesselQueries from '../../queries/vesselQueries'
import { VesselFormData } from '../../data/VesselForm'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { removeMaster, setMaster, setVessel } from '../../redux/reducers/masterReducers'
import PaginationComponent from '../../components/PaginationComponent'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { RouteConstant } from '../../routes/RouteConstant'
import { setHeaderText, setLoader } from '../../redux/reducers/optionsReducers'
import Loader from '../../components/Loader'
import { IconCheckupList, IconUserPlus } from '@tabler/icons-react'
import ProgressBar from '../../components/ProgressBar'
import DrawerComponent from '../../components/DrawerComponent'
import { useApi } from '../../components/ApiProvider'
import SparkleButton from '../../components/SparkleButton'
import { Button, Modal, ModalBody, ModalContent, ModalHeader, Popover, PopoverContent, ModalFooter, useDisclosure } from '@nextui-org/react'
import dropdownQueries from '../../queries/dropdownQueries'
import AccessRestrictionDialog from '../../components/AccessRestrictionDialog'
import { accessMessages } from '../../constants/accessMessages'

const VesselScreen = () => {

  const [result, setResult] = useState([])
  const dispatch = useDispatch()
  const currentPage = useSelector((state)=> state.pagination.currentPage)
  const loader = useSelector((state)=> state.options.loader)
  const user = useSelector((state)=> state.auth.user)
  const [search, setSearch] = useState("")
  
  const {apiData, setApiDataAndNotify} = useApi()

  const navigate = useNavigate()
  
  useEffect(() => {
    dispatch(setLoader(true))
    dispatch(setHeaderText("Vessels"))
    dispatch(removeMaster())
  }, []);

  const vesselList = vesselQueries.useVesselMutationList(
    (res)=>{
      dispatch(setLoader(false))
      setResult(res)
    }
  )

  const dropdown = dropdownQueries.useInspectorAssignment(
    (res)=>{}
  )

  useEffect(() => {
    vesselList.mutateAsync({size: 10, page: currentPage, search})
  }, [currentPage, apiData, search]);

  useEffect(() => {
    if(user?.role?.role === "MANAGER"){
      dropdown.mutateAsync()
    }
  }, []);

  const createMaster = vesselQueries.useVesselMutationCreate(
    (res)=>{
      if(!res?.success){
        toast.error(res?.message)
        return
      }
      if(res?.message === "Error"){
        {res?.error?.map((error, index) => (
          Object?.values(error).map((errorMessage, innerIndex) => (
              toast.error(errorMessage)
            ))
        ))}
        return
      }
      if(res?.message=== "Success"){
          toast.success("Successfully created vessel")
          setApiDataAndNotify(res)
      }
    }
  )

  const handleDetails =(item)=>{
    dispatch(setMaster({
        id: item.id,
        header: ""
      }
    ))
    dispatch(setVessel({
      id: item?.id,
      name: item?.name,
      imo: item?.imo,
      built: item?.built,
      type: item?.type,
      dwt: item?.dwt,
      owner: item?.owner,
    }))
    dispatch(setHeaderText(`Vessel : ${item?.name}`))
    navigate(RouteConstant.VESSELDETAILS)
  }

  const handleInspection =(item)=>{
    dispatch(setMaster({
        id: item.id,
        header: item.name
      }
    ))
    dispatch(setVessel({
      id: item?.id,
      name: item?.name,
      imo: item?.imo,
      built: item?.built,
      type: item?.type,
      dwt: item?.dwt,
      owner: item?.owner,
    }))
    dispatch(setHeaderText(`Vessel : ${item?.name}`))
    navigate(RouteConstant.INSPECTIONHISTORY)
  }

  if(loader){
    return <Loader />
  }

  return (
    <Fragment>
      <div className="w-full max-[410px]:p-3  text-[14px]">
        <div>
            <div className="flex flex-col md:flex-row justify-end items-center gap-4">
              <div className="relative w-full md:w-96 group">
                 <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 rounded-2xl blur-sm group-focus-within:blur-md transition-all duration-300" />
                 <div className="relative">
                   <input
                   type="text"
                   placeholder="Search vessels by name, IMO"
                   className="w-full h-12 pl-14 pr-6 rounded-2xl border-2 border-transparent bg-white/90 backdrop-blur-sm focus:outline-none focus:border-indigo-400 focus:bg-white shadow-lg transition-all duration-300 text-gray-800 placeholder:text-gray-500"
                   value={search}
                   onChange={(e) => setSearch(e.target.value)}
                   />
                   <div className="absolute left-2 top-1/2 transform -translate-y-1/2">
                     <div className="w-8 h-8 bg-primaryGradient rounded-xl flex items-center justify-center">
                       <Search className="w-4 h-4 text-white" />
                     </div>
                   </div>
                   {search && (
                     <button
                     onClick={() => setSearch('')}
                     className="absolute right-4 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center justify-center transition-all duration-200"
                     >
                       <span className="text-gray-500 text-xs">✕</span>
                     </button>
                   )}
                 </div>
              </div>
              {
                user.role.role === "INSPECTOR" &&
                (!result?.isPremium && result?.data?.totalItems >= 2 ? 
                <AccessRestrictionDialog
                btnName="Add Vessel"
                content={accessMessages.vesselLimit}
                />
                :
                <DrawerComponent
                inputFields={VesselFormData} 
                entityForm={createMaster}
                btnName={'Add Vessel'}
                header={'Add New Vessel'}
                />
              )}
            </div>

          {
              result?.data?.items?.map((item, index) =>(
              <div className="flex flex-col gap-6 my-4" key={index}>
                <div className="ship-card border-vesselOrange bg-white card-shadow">
                  <div className="w-full flex flex-col gap-6">
                    <div className="text-[20px] flex justify-between max-[768px]:flex-col font-[600]">
                      <div className='max-[768px]:text-center'>
                        {item?.name}
                      </div>
                      <div className='max-[768px]:flex justify-center'>
                          {progressFind(item?.lastInspection)}
                      </div>
                    </div>
                    <div className='font-bold text-[13px]'>
                      <span className='text-[#737373]'>Inspector</span>
                      <div className='text-[000] flex items-center gap-2'>
                        {item?.user?.fname} {item?.user.lname}
                      </div>
                    </div>
                    <div className="grid grid-cols-12 max-[1601px]:grid-cols-10 max-[965px]:grid-cols-8 max-[577px]:grid-cols-5 gap-y-6 w-full font-[600] text-[12px]">
                      <div className="col-span-3 max-[965px]:col-span-4">
                        <div className="text-[#737373] text-[13px]">
                          Last Updated by
                        </div>
                        <div className="text-[13px]">
                          {item?.updatedBy?.fname} {item?.updatedBy?.lname} @ {moment(item?.createdAt).format('DD-MM-YYYY')}
                        </div>
                      </div>
                      <div className="col-span-1 max-[965px]:col-span-3">
                        <div className="text-[#737373]">
                          IMO No.
                        </div>
                        <div>
                          {item?.imo_no}
                        </div>
                      </div>
                      <div className="col-span-2 max-[965px]:col-span-2">
                        <div className="text-[#737373]">
                          Built
                        </div>
                        <div>
                          {item?.built}
                        </div>
                      </div>
                      <div className="col-span-2 max-[965px]:col-span-3">
                        <div className="text-[#737373]">
                          Remark
                        </div>
                        <div>
                          {item?.remark}
                        </div>
                      </div>
                      <div className="col-span-1 max-[965px]:col-span-2">
                        <div className="text-[#737373]">
                          DWT
                        </div>
                        <div>
                          {item?.dwt}
                        </div>
                      </div>
                    </div>
                    <div className='gap-2 flex justify-end'>
                      <SparkleButton
                      btnName="Vessel Details"
                      Icon={Eye}
                      handleClick={()=>handleDetails(item)}
                      />
                      <SparkleButton
                      btnName="View Inspection"
                      Icon={IconCheckupList}
                      handleClick={()=>handleInspection(item)}
                      />
                      {
                        user?.role?.role === "MANAGER" &&
                        <AssignInspector item={item} dropdown={dropdown} />
                      }
                    </div>
                  </div>
                </div>
              </div>
          ))}
          
          
          {result?.data?.items?.length === 0 && (
            <div className="flex flex-col items-center justify-center text-center py-20">
              <div className="relative mb-8">
                <div className="w-32 h-32 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-full flex items-center justify-center">
                  <Ship size={48} className="text-indigo-500" />
                </div>
                <div className="absolute -inset-4 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 rounded-full animate-ping" />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-800 mb-3">No vessels found</h3>
              <p className="text-gray-600 max-w-md mb-8 leading-relaxed">
                We couldn't find any vessels matching your search criteria. Try adjusting your filters or add a new vessel to get started.
              </p>
              
              <button 
                onClick={() => setSearch('')}
                className="group bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-semibold px-8 py-4 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center gap-3"
              >
                <span>Clear Search</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
              </button>
            </div>
          )}

          <PaginationComponent result={result} />

        </div>
      </div>
    </Fragment>
  )
}

export default VesselScreen

const progressFind =(lastInspection)=>{
    return <ProgressBar data={lastInspection?.successPercentage} />
}



const AssignInspector = ({ item, dropdown }) => {

  const { setApiDataAndNotify } = useApi()

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedInspector, setSelectedInspector] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const handleOpen =()=>{
    setSelectedInspector(null)
    onOpen()
  }

  const handleInspectorSelect = (inspector) => {
    if(inspector?.id === Number(selectedInspector?.id)){
      setSelectedInspector(null)
    }else{
      setSelectedInspector(inspector);
    }
  };

  const assignVessel = vesselQueries.useVesselAssign(
    (res)=>{
      if(res?.success){
        setApiDataAndNotify(new Date())
        toast.success('Assigned Successfully')
        onClose()
      }
    }
  )

  const handleSave = async () => {
    await assignVessel.mutateAsync({
      id: item?.id,
      user_id: selectedInspector?.id
    })
  };

  const filteredInspectors = dropdown?.data?.data
    ?.filter(element => element.id !== item?.user?.managerLinks?.inspector_id)
    ?.filter(element => 
      element?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      element?.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );

  return (
    <>
      <SparkleButton
        btnName="Change Inspector"
        Icon={IconUserPlus}
        handleClick={handleOpen}
      />
      
      <Modal 
        isOpen={isOpen} 
        size="2xl" 
        scrollBehavior='inside'
        onClose={onClose}
        backdrop="opaque"
        classNames={{
          // backdrop: "bg-black/20 backdrop-blur-sm",
          base: "bg-white shadow-2xl border-0",
          header: "border-b border-gray-100",
          body: "py-8 px-8",
          footer: "border-t border-gray-100 bg-gray-50/50"
        }}
      >
        <ModalContent className="rounded-3xl overflow-hidden">
          {(onClose) => (
            <>
              <ModalHeader className="bg-white px-8 py-6">
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 via-purple-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-500/25">
                      <IconUserPlus className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-gray-900 tracking-tight">
                        Assign Inspector
                      </h2>
                      <p className="text-gray-500 text-sm font-medium mt-1">
                        Choose from {filteredInspectors?.length || 0} available inspectors
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Current</div>
                    <div className="text-sm font-medium text-gray-700">
                      {item?.user ? item?.user?.fname + " " + item?.user?.lname  : 'None'}
                    </div>
                  </div>
                </div>
              </ModalHeader>
              
              <ModalBody className="bg-white">
                <div className="relative mb-4">
                  <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Search by name or email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-14 pr-6 py-4 bg-gray-50 border-0 rounded-2xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500/20 focus:shadow-lg transition-all duration-300 text-base font-medium"
                  />
                  {searchTerm && (
                    <button
                      onClick={() => setSearchTerm('')}
                      className="absolute inset-y-0 right-5 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-1 gap-4">
                  {filteredInspectors?.map((element, index) => (
                    <div
                      key={element.id || index}
                      className={`group relative p-3 rounded-2xl cursor-pointer transition-all duration-500 hover:shadow-xl ${
                        selectedInspector?.id === element.id
                          ? 'bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border-2 border-blue-200 shadow-lg shadow-blue-500/10 scale-[1.02]'
                          : 'bg-white border border-gray-100 hover:border-gray-200 hover:shadow-md shadow-sm'
                      }`}
                      onClick={() => handleInspectorSelect(element)}
                    >

                      <div className="flex items-center gap-5">
                        <div className="relative flex-shrink-0">
                          <div className="w-10 h-10 bg-primaryGradient rounded-2xl flex items-center justify-center shadow-lg shadow-blue-500/20">
                            <span className="text-white font-bold">
                              {element?.name?.charAt(0)?.toUpperCase() || 'U'}
                            </span>
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-start justify-between">
                            <div>
                              <span className="text-sm font-medium text-gray-900 mb-1">
                                {element?.name}
                              </span>
                            </div>
                          </div>
                          
                          {element?.email && (
                            <div className="flex items-center gap-2">
                              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                              </svg>
                              <span className="text-gray-600 text-sm font-medium">
                                {element.email}
                              </span>
                            </div>
                          )}
                        </div>
                        {selectedInspector?.id === element.id && (
                          <div className="w-6 h-6 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center shadow-lg shadow-blue-500/30 ring-4 ring-white">
                            <Check size={14} color='#fff' />
                          </div>
                        )}
                      </div>

                      <div className={`absolute inset-0 rounded-2xl transition-opacity duration-300 pointer-events-none ${
                        selectedInspector?.id === element.id 
                          ? 'bg-gradient-to-r from-blue-500/5 to-purple-500/5 opacity-100'
                          : 'bg-gradient-to-r from-blue-500/3 to-indigo-500/3 opacity-0 group-hover:opacity-100'
                      }`}></div>
                    </div>
                  ))}
                  
                  {(!filteredInspectors || filteredInspectors.length === 0) && (
                    <div className="text-center py-16">
                      <div className="w-20 h-20 bg-gray-50 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-inner">
                        <svg className="w-10 h-10 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                        </svg>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">No inspectors found</h3>
                      <p className="text-gray-500 font-medium">
                        {searchTerm ? 'Try adjusting your search terms' : 'No inspectors are currently available'}
                      </p>
                    </div>
                  )}
                </div>
              </ModalBody>
              
              <ModalFooter className="px-8 py-6">
                <div className="flex justify-between items-center w-full">
                  <div className="flex items-center gap-3">
                    {selectedInspector ? (
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-xl flex items-center justify-center">
                          <span className="text-white font-bold text-sm">
                            {selectedInspector.name?.charAt(0)?.toUpperCase()}
                          </span>
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedInspector.name}
                          </p>
                          <p className="text-xs text-gray-500">
                            Selected for assignment
                          </p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-gray-500 font-medium">
                        Select an inspector to continue
                      </p>
                    )}
                  </div>
                  
                  <div className="flex gap-4">
                    <Button 
                      color="danger" 
                      variant="light" 
                      onPress={onClose}
                      className="font-bold px-8 py-3 rounded-xl hover:bg-red-50 transition-all duration-200"
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onPress={handleSave}
                      isDisabled={!selectedInspector}
                      className={`font-bold px-8 py-3 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 shadow-lg hover:shadow-xl transform transition-all duration-200 ${
                        selectedInspector ? 'hover:scale-105' : 'opacity-50 cursor-not-allowed'
                      }`}
                    >
                      Assign Inspector
                    </Button>
                  </div>
                </div>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};